import { render } from "./Palettes.vue?vue&type=template&id=2e233d12&scoped=true"
import script from "./Palettes.vue?vue&type=script&lang=js"
export * from "./Palettes.vue?vue&type=script&lang=js"

import "./Palettes.vue?vue&type=style&index=0&id=2e233d12&scoped=true&lang=css"

import exportComponent from "/builds/site-palette/palette.site-new/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2e233d12"]])

export default __exports__